import { css } from 'glamor';
import typography from '../../utils/typography';

const bioWrapper = css({
  float: 'left',
  width: '100%',
});

const bioInner = css({
  display: 'flex',
  alignItems: 'top',
  marginBottom: typography.rhythm(2.5),
  '@media(max-width: 48em)': {
    flexWrap: 'wrap',
    textAlign: 'center',
  },
});

const avatarStyle = css({
  marginRight: typography.rhythm(2),
  marginBottom: 0,
  width: typography.rhythm(4),
  height: typography.rhythm(4),
  borderRadius: '50%',
  '@media(max-width: 48em)': {
    marginRight: 0,
    marginBottom: typography.rhythm(2),
  },
});

const bracket = css({
  margin: `0 ${typography.rhythm(0.5)}`,
  opacity: 0.3,
});

const header = css({
  marginTop: 0,
});

const li = css({
  marginBottom: typography.rhythm(0.1),
});

const ribbon = css({ width: '100%', display: 'flex' });

export { bioWrapper, bioInner, avatarStyle, bracket, header, li, ribbon };



// WEBPACK FOOTER //
// ./src/components/Bio/styles.js